module.exports = __webpack_public_path__ + "static/img/icon_2.2cee500.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flow/icon_2.png
// module id = fiOy
// module chunks = 0